/**
 * Class representing a Preloader utility.
 * Provides static methods to handle preloaders for popups and the body of the document.
 */
export default class PreloaderClass {

    /**
     * Creates and activates a preloader for a specified popup element.
     * @param {string} popupID - The ID of the popup element.
     */
    static forPopup(popupID) {
        const popup = document.getElementById(popupID);
        if (!popup) return;

        this.removeExistingPreloader(popup, '.popup-preloader');

        const preloader = document.createElement('div');
        preloader.classList.add('popup-preloader');
        popup.appendChild(preloader);

        setTimeout(() => popup.classList.add('popup-preloader-active'), 100);
    }

    /**
     * Creates and activates a preloader for the body of the document.
     */
    static forBody() {
        this.removeExistingPreloader(document.body, '#body-preloader');

        const preloader = document.createElement('div');
        preloader.classList.add('body-preloader');
        preloader.setAttribute('id', 'body-preloader');
        document.body.appendChild(preloader);

        setTimeout(() => document.body.classList.add('body-preloader-active'), 100);
    }

    /**
     * Stops and removes any active preloaders from the document.
     */
    static stop() {
        if(document.getElementById('body-preloader')){
            this.removePreloader(document.getElementById('body-preloader'), 'body-preloader-active');
        }
        if(document.querySelector('.popup-preloader')){
            this.removePreloader(document.querySelector('.popup-preloader'), 'popup-preloader-active');
        }
    }

    /**
     * Removes an existing preloader element if it exists.
     * @param {Element} parent - The parent element to search within.
     * @param {string} selector - The CSS selector for the preloader element.
     * @private
     */
    static removeExistingPreloader(parent, selector) {
        const existingPreloader = parent.querySelector(selector);
        if (existingPreloader) existingPreloader.remove();
    }

    /**
     * Stops the preloader animation and removes the preloader element.
     * @param {Element} preloaderElement - The preloader element to remove.
     * @param {string} activeClass - The CSS class to remove for stopping the animation.
     * @private
     */
    static removePreloader(preloaderElement, activeClass) {
        if (!preloaderElement) return;
        if(document.querySelector(`.${activeClass}`)){
            document.querySelector(`.${activeClass}`).classList.remove(activeClass);
        }
        //document.getElementsByClassName(`.${activeClass}`).classList.remove(activeClass);
        setTimeout(() => preloaderElement.remove(), 500);
    }
}

window.Preloader = PreloaderClass;
